import { ReactNode, useCallback, useState } from 'react';
import { Collapse } from '@mui/material';
import classNames from 'classnames';
import { AgExpandIcon } from 'app/agriculture/infobox/common/AgExpandIcon/AgExpandIcon';
import './StackBoxSection.scss';

interface StackBoxSectionProps {
    id?: string;
    title: string;
    defaultExpanded?: boolean;
    className?: string;
    children?: ReactNode;
}

export function StackBoxSection({
    id,
    title,
    children,
    className,
    defaultExpanded = false,
}: StackBoxSectionProps) {
    const [expanded, setExpanded] = useState(defaultExpanded);

    const handleClick = useCallback(() => {
        setExpanded((expanded) => !expanded);
    }, []);

    return (
        <div
            id={id}
            data-testid="StackBoxSection"
            className={classNames('StackBoxSection', className, {
                'StackBoxSection--expanded': expanded,
            })}
        >
            <button id={`${id}-header`} className="StackBoxSection__header" onClick={handleClick}>
                <label data-testid="StackBoxSectionTitle">{title}</label>
                <div className="StackBoxSection__expand-icon">
                    <AgExpandIcon expanded={expanded} />
                </div>
            </button>
            <Collapse
                in={expanded}
                classes={{
                    root: 'StackBoxSection__collapse',
                    wrapper: 'StackBoxSection__collapse-wrapper',
                }}
            >
                <div className="StackBoxSection__content">{children}</div>
            </Collapse>
        </div>
    );
}
